import { useSelector } from 'react-redux';
import { formatStatisticalNumberOutput, getStatePropertyItemsCount } from '@helpers/customerHelpers';

function FavoritesCounter() {
    const favorites = useSelector((state: any) => state.favorites?.products);
    const favoritesCount = getStatePropertyItemsCount(favorites);

    return (
        <span className="product-tabs__count product-tabs__count--favourites">
            {formatStatisticalNumberOutput(favoritesCount)}
        </span>
    );
}

export default FavoritesCounter;
